import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '@app/auth/services/authentication.service';
import { AuthUser } from '@app/core/models/auth-user';
import { SecurityPermissionName } from '@app/core/models/permission';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'portal-system-admin-main-nav',
  templateUrl: './system-admin-main-nav.component.html',
  styles: [],
  standalone: false,
})
export class SystemAdminMainNavComponent implements OnInit {
  authUser$!: Observable<AuthUser>;

  Permission = SecurityPermissionName;

  constructor(private authenticationService: AuthenticationService) {}

  ngOnInit(): void {
    this.authUser$ = this.authenticationService.authUser$.pipe(untilDestroyed(this));
  }
}
